/* eslint-disable no-promise-executor-return */
import * as STORAGE from '@/constants/STORAGE';

import { apiSetToken } from '@/services/api-recebimentoweb';

import storage from '@/services/storage';

export default {
  namespaced: true,

  state: {
    accessToken: null,
    user: null,
  },

  getters: {
    accessToken: (state) => state.accessToken,
    user: (state) => state.user,
  },

  actions: {
    async $_setup({ dispatch, commit }) {
      const accessToken = await storage.getItem(STORAGE.TOKEN);
      if (!accessToken) return;

      if (new Date() > new Date(accessToken.expires)) {
        await storage.removeItem(STORAGE.TOKEN);
        return;
      }

      commit('SET_TOKEN', accessToken);

      await new Promise((resolve) => setTimeout(resolve, 100));
      await dispatch('loadUser');
    },

    async authenticate({ commit, dispatch }, payload) {
      const accessToken = await dispatch('users/login', payload, { root: true });

      await storage.setItem(STORAGE.TOKEN, accessToken);
      commit('SET_TOKEN', accessToken);

      // Parametros adicionais
      const USER = await dispatch('users/findById', { id: accessToken.userId }, { root: true });

      await storage.setItem(STORAGE.TOKEN, {
        ...accessToken,
        agfiscal: USER.usefiscalagrocampo,
        idpessoa: USER.pesid,
      });
      commit('SET_TOKEN', {
        ...accessToken,
        agfiscal: USER.usefiscalagrocampo,
        idpessoa: USER.pesid,
      });

      await new Promise((resolve) => setTimeout(resolve, 100));
      await dispatch('loadUser');
    },

    async authenticateLocal(_, { data }) {
      const accessToken = {
        token: 'f60a4a79-37bf-44b3-a661-ce18eb83e6e1',
        agfiscal: data.agfiscal,
        idpessoa: data.idpessoa,
      };

      await sessionStorage.setItem(STORAGE.TOKENLOCAL.tokenlocal, JSON.stringify(accessToken));
    },

    async unauthenticate({ commit }) {
      // dispatch('users/logout', null, { root: true })
      //   .catch();

      await sessionStorage.removeItem(STORAGE.TOKEN);
      commit('SET_TOKEN', null);
      commit('SET_USER', null);
    },

    async loadUser({ commit }) {
      const user = {
        usenome: 'USUARIO',
        usechave: '@555',
      };
      commit('SET_USER', user);
    },

    // unauthenticate customizado
    async logout({ commit }) {
      await storage.removeItem(STORAGE.TOKEN);
      await sessionStorage.removeItem(STORAGE.TOKENLOCAL);
      commit('SET_TOKEN', null);
      commit('SET_USER', null);
    },

  },

  mutations: {
    SET_TOKEN(state, accessToken) {
      state.accessToken = accessToken;
      apiSetToken(accessToken?.token);
    },

    SET_USER(state, user) {
      state.user = user;
    },
  },
};
